import ReducerRegistry from '../base/redux/ReducerRegistry';
import { ADD_FACE_EXPRESSION, ADD_TO_FACE_EXPRESSIONS_BUFFER, CLEAR_FACE_EXPRESSIONS_BUFFER, UPDATE_FACE_COORDINATES } from './actionTypes';
const defaultState = {
    faceBoxes: {},
    faceExpressions: {
        happy: 0,
        neutral: 0,
        surprised: 0,
        angry: 0,
        fearful: 0,
        disgusted: 0,
        sad: 0
    },
    faceExpressionsBuffer: [],
    recognitionActive: false
};
ReducerRegistry.register('features/face-landmarks', (state = defaultState, action) => {
    switch (action.type) {
        case ADD_FACE_EXPRESSION: {
            return Object.assign(Object.assign({}, state), { faceExpressions: Object.assign(Object.assign({}, state.faceExpressions), { [action.faceExpression]: state.faceExpressions[action.faceExpression] + action.duration }) });
        }
        case ADD_TO_FACE_EXPRESSIONS_BUFFER: {
            return Object.assign(Object.assign({}, state), { faceExpressionsBuffer: [...state.faceExpressionsBuffer, action.faceExpression] });
        }
        case CLEAR_FACE_EXPRESSIONS_BUFFER: {
            return Object.assign(Object.assign({}, state), { faceExpressionsBuffer: [] });
        }
        case UPDATE_FACE_COORDINATES: {
            return Object.assign(Object.assign({}, state), { faceBoxes: Object.assign(Object.assign({}, state.faceBoxes), { [action.id]: action.faceBox }) });
        }
    }
    return state;
});
